import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { IoMdArrowDropup } from "react-icons/io";
import { MdOutlineArrowDropDown } from "react-icons/md";
import { SquareMinus, SquarePlus } from "lucide-react";
import { useDispatch } from "react-redux";
import { setMarketName, setRunningData } from "../../redux/slices/fullmarketSlice";
import { getLegues, getMatchesList } from "../../api";

const SidebarMenuItem = ({ item, isOpen, depth = 0, toggleDrawer }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const [leagues, setLeagues] = useState([]);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [matchList, setMatchList] = useState([]);

  const getBackgroundColorClass = (depth) => {
    const bgClasses = ["bg-white", "bg-white text-black", "bg-white text-offwhite"];
    return bgClasses[depth] || "bg-gray-900";
  };

  const fetchLeagues = async () => {
    if (!item.event) return;
    try {
      const res = await getLegues(item.event);
      setLeagues(res.data.data);
    } catch (err) {
      console.error("Leagues fetch failed", err);
    }
  };

  const fetchMatchesList = async (eventId, marketId) => {
    try {
      const res = await getMatchesList(eventId, marketId);
      setMatchList(res.data.data);
    } catch (err) {
      console.error("Match list fetch failed", err);
    }
  };

  const toggleMainMenu = () => {
    setIsExpanded((prev) => !prev);
    if (!leagues.length) fetchLeagues();
  };

  const toggleSubMenu = (marketId) => {
    setOpenSubMenu((prev) => (prev === marketId ? null : marketId));
    if (marketId) fetchMatchesList(item.event, marketId);
  };

  const handleMarketClick = (match) => {
    dispatch(setRunningData(match?.matchRunners));
    dispatch(setMarketName(match?.markets));
    if (isOpen) toggleDrawer();
    navigate(`/full-market?eventType=${match?.sportId}&eventId=${match?.eventId}&marketId=${match?.marketId}&joinedMarketIds=${match?.joinedMarketIds}&competitionId=${match?.competitionId}&bm=${match?.bm}&fancy=${match?.fancy}&pc=${e?.pc}&eventName=${e?.eventName}`);
  };

  return (
    <div className="border-b border-gray-200">
      <NavLink
        to={item.link && !item.subItems ? item.link : "#"}
        onClick={() => item.subItems && toggleMainMenu()}
        className={`flex justify-between items-center py-2 pl-3 pr-1 cursor-pointer hover:bg-[#27a6c3] hover:text-white ${getBackgroundColorClass(depth)}`}
      >
        <div className="flex items-center" style={{ paddingLeft: `${depth * 16}px` }}>
          {depth === 0 && item.icon && (typeof item.icon === "string" ? (
            <img src={item.icon} className="size-5 mr-2" alt="icon" />
          ) : (
            <item.icon className="size-5 mr-2" />
          ))}
          <span className={depth > 0 ? "text-[12px]" : "text-[14px] font-[700] font-sans"}>{item.label}</span>
        </div>
        {item.subItems && (
          depth === 0 ? (isExpanded ? <IoMdArrowDropup size={20} /> : <MdOutlineArrowDropDown size={24} />)
                    : (isExpanded ? <SquareMinus size={11} /> : <SquarePlus size={11} />)
        )}
      </NavLink>

      {isOpen && isExpanded && leagues?.length > 0 && (
        <div>
          {leagues.map((league) => (
            <div key={league?.competitionId} className="border-t border-gray-100">
              <div
                className="py-2 px-4 flex justify-between items-center hover:bg-gray-100 cursor-pointer text-[10px]"
                onClick={() => toggleSubMenu(league?.competitionId)}
              >
                <p className="text-gray-700 font-bold">{league?.competitionName}</p>
                <span className="text-xs">{openSubMenu === league?.competitionId ? "−" : "+"}</span>
              </div>

              {openSubMenu === league?.competitionId && (
                <div className="bg-gray-50">
                  {matchList.map((match) => (
                    <div
                      key={match?.eventId}
                      className="py-2 px-4 text-[10px] hover:bg-gray-200 cursor-pointer"
                      onClick={() => handleMarketClick(match)}
                    >
                      {match?.eventName}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarMenuItem;
